module.exports = __webpack_public_path__ + "static/media/access_denied.1812e35a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/access_denied.svg
// module id = 2065
// module chunks = 0